const base = process.env.REACT_APP_API_URL || '';

export const notifyPurchase = async (sessionId) => {
  try {
    await fetch(`${base}/api/notify/purchase`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId }),
    });
  } catch (err) {
    console.error('Erro ao enviar notificação de compra:', err);
  }
};

export const refundOrder = async ({ adminEmail, order }) => {
  const res = await fetch(`${base}/api/orders/refund`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      adminEmail,
      sessionId: order.sessionId || order.id,
      orderStatus: order.status,
      customerEmail: order.customerEmail,
      customerName: order.customerName,
      items: order.items,
      total: order.total,
    }),
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Erro ao reembolsar pedido');
  }
  return data;
};

export const notifyStatusUpdate = async ({ adminEmail, order, status, trackingCode, localDelivery }) => {
  try {
    const res = await fetch(`${base}/api/notify/status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        adminEmail,
        sessionId: order.sessionId || order.id,
        status,
        customerEmail: order.customerEmail,
        customerName: order.customerName,
        items: order.items,
        total: order.total,
        trackingCode,
        localDelivery: localDelivery ?? order.localDelivery,
      }),
    });
    if (!res.ok) {
      const data = await res.json();
      throw new Error(data.error || 'Erro ao enviar notificação');
    }
    return true;
  } catch (err) {
    console.error('Erro ao enviar notificação de status:', err);
    throw err;
  }
};
